import Footer from './components/Footer';
import LandingNav from './components/LandingNav';
import { footerNavigation } from './contentSections';

export default function ContactPage() {
  return (
    <div className='bg-background text-foreground'>
      <LandingNav />
      <main className='mx-auto max-w-3xl px-6 py-32 lg:px-8'>
        <h1 className='text-4xl font-bold mb-4'>Contact Us</h1>
        <p className='text-muted-foreground text-lg leading-relaxed mb-10'>
          Have a question, a concern, or want to get your organization listed? We'd love to hear from you.
        </p>

        <div className='space-y-6'>
          <div className='rounded-xl border border-border p-6'>
            <h2 className='text-lg font-semibold mb-1'>General Inquiries</h2>
            <p className='text-muted-foreground leading-relaxed'>
              For general questions about App, email us at{' '}
              <a href='mailto:info@App.ca' className='text-primary hover:underline'>
                info@App.ca
              </a>
            </p>
          </div>

          <div className='rounded-xl border border-border p-6'>
            <h2 className='text-lg font-semibold mb-1'>Report Content</h2>
            <p className='text-muted-foreground leading-relaxed'>
              If you have encountered content on the platform that you believe violates our{' '}
              <a href='/terms' className='text-primary hover:underline'>Terms of Service</a>,
              please email us at{' '}
              <a href='mailto:report@App.ca' className='text-primary hover:underline'>
                report@App.ca
              </a>{' '}
              with the details and we will review it promptly.
            </p>
          </div>

          <div className='rounded-xl border border-border p-6'>
            <h2 className='text-lg font-semibold mb-1'>Register Your Organization</h2>
            <p className='text-muted-foreground leading-relaxed'>
              Want to list your Center, school, or organization on App? Create an account
              and register your organization directly through the platform, or contact us at{' '}
              <a href='mailto:organizations@App.ca' className='text-primary hover:underline'>
                organizations@App.ca
              </a>
            </p>
          </div>
        </div>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}



